import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import {
  M8UsersData,
  M8PaginationParams,
  M8UserSortableField,
} from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

export const getActiveUsers = async (
  params: M8PaginationParams<M8UserSortableField>
): Promise<M8UsersData> => {
  const response = await customFetch(
    getM8AdminURL(`getActiveUsers?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
